import { NumberFormat } from '~/converters/number-format-constants';
import { DataType } from '~/models/data-type';

export class NumberScaleUtils {
	public static dataTypeHasScale(dataType: DataType): boolean {
		return (
			['BigDecimal', 'Currency', 'Percentage'].indexOf(dataType.name) > -1
		);
	}

	public static getScale(
		dataTypeName: string,
		value: string | number | undefined | null,
		scale: number | undefined | null,
	) {
		switch (dataTypeName) {
			case 'Currency':
				return NumberScaleUtils.getScaleCurrency(value, scale);
			case 'Integer':
			case 'Long':
				return 0; // Force zero scale
			default:
				return NumberScaleUtils.getScaleDefault(value, scale);
		}
	}

	public static getScaleDefault(
		value: string | number | undefined | null,
		scale: number | undefined | null,
	): number {
		if (scale === undefined || scale === null) {
			// if scale not set, set it according to number of decimal digits in value
			if (
				value !== undefined &&
				value !== null &&
				value.toString().indexOf('.') !== -1
			) {
				scale =
					value.toString().length - value.toString().indexOf('.') - 1;
			} else {
				// if decimal part is not optional, ensure at least one scale
				// York: Umit wanted an extra 0 for decimal with unset scales
				scale = NumberFormat.Decimal.Optional ? 0 : 1;
			}
		}
		return scale;
	}

	/**
	 * Currency scale defaults to 2 (NumberFormat.Currency.Digits)
	 */
	public static getScaleCurrency(
		value: string | number | undefined,
		scale: number | undefined | null,
	): number {
		if (scale === undefined || scale === null) {
			scale = NumberFormat.Currency.Digits;
		}
		return NumberScaleUtils.getScaleDefault(value, scale);
	}
}
